export const SWITCH_THEME = "SWITCH_THEME";
export const TOGGLE_THEME = "TOGGLE_THEME";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const TOGGLE_PROJECT_LIST = "TOGGLE_PROJECT_LIST";
export const TOGGLE_PROJECT_DETAILS = "TOGGLE_PROJECT_DETAILS";
